import React from "react";
import { Box, Grid, Typography, Chip } from "@mui/material";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RTooltip } from "recharts";
import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import MiniStat from "../../components/MiniStat";
import { tokens } from "../../theme";
import { acqFunnel, ftdsBySource, acqByState } from "../../data/mockData";

const mono = '"IBM Plex Mono", monospace';

export default function Acquisition() {
  const top = acqFunnel[0].value;
  return (
    <Box>
      <PageHeader title="Acquisition" crumb="Monitor / Acquisition" subtitle="Registrations → first deposit" />

      <Grid container spacing={1.75} sx={{ mb: 1.75 }}>
        <Grid item xs={6} md={3}><MiniStat label="Registrations" value="1,940" delta="+8.1%" up color={tokens.primary} /></Grid>
        <Grid item xs={6} md={3}><MiniStat label="New signups today" value="27" delta="+5" up color={tokens.secondary} /></Grid>
        <Grid item xs={6} md={3}><MiniStat label="Cost / FTD" value="$38.20" delta="-4.2%" up color={tokens.accent} /></Grid>
        <Grid item xs={6} md={3}><MiniStat label="Signup → FTD" value="10.9%" delta="+0.6pt" up color={tokens.blue} /></Grid>
      </Grid>

      <Grid container spacing={1.75}>
        <Grid item xs={12} lg={6}>
          <SectionCard title="Acquisition funnel" subtitle="Last 7 days">
            {acqFunnel.map((f) => {
              const pct = Math.round((f.value / top) * 100);
              return (
                <Box key={f.label} sx={{ mb: 1.4 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                    <Typography variant="caption" color="text.secondary">{f.label}</Typography>
                    <Typography sx={{ fontFamily: mono, fontWeight: 600, fontSize: 12 }}>
                      {f.value.toLocaleString()} <span style={{ color: tokens.textDim }}>· {pct}%</span>
                    </Typography>
                  </Box>
                  <Box sx={{ height: 8, borderRadius: 4, background: tokens.bg, overflow: "hidden" }}>
                    <Box sx={{ height: "100%", width: `${pct}%`, background: f.color, borderRadius: 4 }} />
                  </Box>
                </Box>
              );
            })}
          </SectionCard>
        </Grid>

        <Grid item xs={12} lg={6}>
          <SectionCard title="FTDs by source" subtitle="Last 7 days">
            <Box sx={{ height: 240 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={ftdsBySource} margin={{ left: -18, right: 8, top: 8 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke={tokens.border} vertical={false} />
                  <XAxis dataKey="source" stroke={tokens.textDim} fontSize={11} tickLine={false} axisLine={false} />
                  <YAxis stroke={tokens.textDim} fontSize={11} tickLine={false} axisLine={false} />
                  <RTooltip cursor={{ fill: "rgba(23,26,43,0.04)" }} contentStyle={{ background: tokens.surface2, border: `1px solid ${tokens.border}`, borderRadius: 8 }} />
                  <Bar dataKey="ftds" radius={[6, 6, 0, 0]} fill={tokens.primary} />
                </BarChart>
              </ResponsiveContainer>
            </Box>
          </SectionCard>
        </Grid>

        <Grid item xs={12}>
          <SectionCard title="By state" subtitle="Registrations & conversion">
            <Box component="table" sx={{ width: "100%", borderCollapse: "collapse", "& th": { textAlign: "left", color: tokens.textDim, fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, p: "10px 12px", borderBottom: `1px solid ${tokens.border}` }, "& td": { p: "12px", borderBottom: `1px solid ${tokens.border}`, fontSize: 13, fontFamily: mono } }}>
              <thead><tr><th>State</th><th>Registrations</th><th>FTDs</th><th>Cost / FTD</th><th>Conv.</th></tr></thead>
              <tbody>
                {acqByState.map((r) => (
                  <tr key={r.state}>
                    <td><Chip size="small" label={r.state} sx={{ bgcolor: tokens.surface2, color: tokens.text, fontWeight: 600 }} /></td>
                    <td>{r.registrations}</td><td>{r.ftds}</td><td>{r.cpf}</td><td>{r.conv}</td>
                  </tr>
                ))}
              </tbody>
            </Box>
          </SectionCard>
        </Grid>
      </Grid>
    </Box>
  );
}
